/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_Improving_DescInputs */

const en_privacy_section_3_item_improving_desc = /** @type {(inputs: Privacy_Section_3_Item_Improving_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`analytics data helps us understand how visitors use our site and identify areas for improvement`)
};

const lv_privacy_section_3_item_improving_desc = /** @type {(inputs: Privacy_Section_3_Item_Improving_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`analītikas dati palīdz mums saprast, kā apmeklētāji izmanto mūsu vietni, un identificēt uzlabojumu jomas`)
};

/**
* | output |
* | --- |
* | "analytics data helps us understand how visitors use our site and identify areas for improvement" |
*
* @param {Privacy_Section_3_Item_Improving_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_improving_desc = /** @type {((inputs?: Privacy_Section_3_Item_Improving_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_Improving_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_improving_desc(inputs)
	return en_privacy_section_3_item_improving_desc(inputs)
});